import React from 'react';
import { Target, Award, TrendingUp, CheckCircle } from 'lucide-react';
import Icon from '../../../components/AppIcon';


const ProgressOverview = ({ summary }) => {
  const stats = [
    {
      icon: Target,
      label: 'Active Goals',
      value: summary?.activeGoals || 0,
      color: 'text-purple-600',
      bgColor: 'bg-purple-100'
    },
    {
      icon: CheckCircle,
      label: 'Completed Goals',
      value: summary?.completedGoals || 0,
      color: 'text-green-600',
      bgColor: 'bg-green-100'
    },
    {
      icon: Award,
      label: 'Milestones Reached',
      value: summary?.achievedMilestones || 0,
      color: 'text-yellow-600',
      bgColor: 'bg-yellow-100'
    },
    {
      icon: TrendingUp,
      label: 'Overall Progress',
      value: `${summary?.milestoneProgress || 0}%`,
      color: 'text-blue-600',
      bgColor: 'bg-blue-100'
    }
  ];

  return (
    <div className="bg-white rounded-xl shadow-lg p-6">
      <h2 className="text-2xl font-bold text-gray-900 mb-6">Progress Overview</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {stats?.map((stat, index) => {
          const Icon = stat?.icon;
          return (
            <div
              key={index}
              className="bg-gradient-to-br from-gray-50 to-gray-100 rounded-lg p-6 border-2 border-gray-200"
            >
              <div className={`${stat?.bgColor} w-12 h-12 rounded-lg flex items-center justify-center mb-4`}>
                <Icon className={`w-6 h-6 ${stat?.color}`} />
              </div>
              <div className="text-3xl font-bold text-gray-900 mb-1">
                {stat?.value}
              </div>
              <div className="text-sm text-gray-600">
                {stat?.label}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ProgressOverview;